<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top-off" style="background-color: #ffffff">
	<!-- 						  -->
	<!-- Display Visitor Selector -->
	<!-- 						  -->
	<div>
		<VPP-VisitorSelector></VPP-VisitorSelector>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body1">
		<div>
			<div>
				<button [disabled]="isProcessing == true" class="btn btn-primary" style="margin-left: 0px" (click)="onAddBlockedVisitor()">
					Add Blocked Visitor
				</button>
				<button [disabled]="isProcessing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEditVisitor()">Edit Visitor</button>
				<button [disabled]="isProcessing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onValidateVisitor()">
					Validate Visitor
				</button>
				<button [disabled]="isProcessing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onImportBlockList()">
					Import Block List
				</button>
				<button [disabled]="isProcessing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onExportBlockList()">
					Export Block List
				</button>
				<button [disabled]="isProcessing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onTransferVisitors()">
					Transfer to VPP3
				</button>
			</div>

			<!--Report Error Message-->
			<div *ngIf="isProcessing || errorMessage" class="TopMargin">
				<div name="Saveing" *ngIf="isProcessing" class="alert alert-info" style="margin-bottom: 0px">Processing.Please wait...</div>
				<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger" style="margin-bottom: 0px">
					{{ errorMessage }}
				</div>
			</div>
		</div>
	</div>

	<!-- 		 	   -->
	<!-- Date Selector -->
	<!-- 	  		   -->
	<div class="date-body">
		<div class="selector-body">
			<!-- 				 	-->
			<!-- DateRange Selector -->
			<!-- 				 	-->
			<div class="selector-item">
				<div>
					<label>Date Range</label>
				</div>

				<div style="margin-left: 10px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="DateRangeSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedDateRange"
						(ngModelChange)="onDateRangeChange($event)"
					>
						<option *ngFor="let r of lstDateRange" [ngValue]="r">
							{{ r.DateRangeDesc }}
						</option>
					</select>
				</div>
			</div>

			<!-- 			-->
			<!-- Start Date -->
			<!-- 			-->
			<div class="selector-item" [style.display]="this.SelectedDateRange.DateRangeID == 5 ? 'flex' : 'none'">
				<div>
					<label>Start Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[style]="{ width: '100%' }"
						[inputStyle]="{ width: '100%' }"
						[(ngModel)]="StartDate"
						(ngModelChange)="onStartDateChange($event)"
						[showTime]="false"
						hourFormat="12"
						showIcon="true"
						inputId="startdate"
					></p-calendar>
				</div>
			</div>

			<!-- 			-->
			<!-- End Date -->
			<!-- 			-->
			<div class="selector-item" [style.display]="this.SelectedDateRange.DateRangeID == 5 ? 'flex' : 'none'">
				<div>
					<label>End Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[style]="{ width: '100%' }"
						[inputStyle]="{ width: '100%' }"
						[(ngModel)]="EndDate"
						(ngModelChange)="onEndDateChange($event)"
						[showTime]="false"
						hourFormat="12"
						showIcon="true"
						inputId="enddate"
					></p-calendar>
				</div>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body2">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()" [disabled]="isBusy == true">Print</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
		<!--   			   -->
		<!-- Error Message -->
		<!-- 			   -->
		<div style="margin-left: 20px; color: #e61010; align-items: center" [style.display]="ErrorMessage != '' ? 'flex' : 'none'">
			<label style="font-size: 15px">{{ ErrorMessage }}</label>
		</div>
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total visitor logs: {{ lstVisitorLog.length }}&nbsp;&nbsp;&nbsp;&nbsp;(no filters)</label><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>
</div>

<!-- 				  	       -->
<!-- Display Visitor Log Items -->
<!-- 					       -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->

	<p-table
		#mydt
		[value]="lstVisitorLog"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedVisitorLog"
		dataKey="VisitorLogID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th class="fixwidth-06">
					<div class="table-filter-row-group">
						<!-- 				   -->
						<!-- Display When Busy -->
						<!-- 				   -->
						<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
							<img class="busy-img" src="assets/images/loading.gif" />
						</div>
						<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
					</div>
				</th>

				<th>
					<p-columnFilter field="VisitorLogStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisitorLogStatusDesc
								[ngModel]="value"
								[options]="lstVisitorLogStatusDescs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<!-- PlaceHolder (logDT)-->
				</th>

				<th>
					<p-columnFilter field="EntryFacilityLocation" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterEntryFacilityLocation
								[ngModel]="value"
								[options]="lstEntryFacilityLocations"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="DestinationFacilityLocation" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDestinationFacilityLocation
								[ngModel]="value"
								[options]="lstDestinationFacilityLocations"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="ScanStation" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterScanStation
								[ngModel]="value"
								[options]="lstScanStations"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="Barcode" matchMode="startsWith" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="FacilityName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterFacilityName
								[ngModel]="value"
								[options]="lstFacilityNames"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr style="height: 4rem">
				<th class="fixwidth-06"></th>
				<th pSortableColumn="VisitorLogStatusDesc">Log Status<p-sortIcon field="VisitorLogStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="logDT">Log Date<p-sortIcon field="logDT"></p-sortIcon></th>
				<th pSortableColumn="EntryFacilityLocation">Entry<p-sortIcon field="EntryFacilityLocation"></p-sortIcon></th>
				<th pSortableColumn="DestinationFacilityLocation">Destination<p-sortIcon field="DestinationFacilityLocation"></p-sortIcon></th>
				<th pSortableColumn="ScanStation">Visitor Station<p-sortIcon field="ScanStation"></p-sortIcon></th>
				<th pSortableColumn="Barcode">Pass ID<p-sortIcon field="Barcode"></p-sortIcon></th>
				<th pSortableColumn="FacilityName">Facility<p-sortIcon field="FacilityName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rVisitorLogItem>
			<tr [pSelectableRow]="rVisitorLogItem">
				<td class="fixwidth-06">
					<!-- Fee space filler -->
				</td>

				<td>
					<div class="table-data-log">
						{{ rVisitorLogItem.VisitorLogStatusDesc }}
					</div>
				</td>

				<td>
					<div class="table-data-log">
						{{ rVisitorLogItem.logDT | date : "M/d/yyyy h:mm a" }}
					</div>
				</td>

				<td>
					<div class="table-data-log">
						{{ rVisitorLogItem.EntryFacilityLocation }}
					</div>
				</td>

				<td>
					<div class="table-data-log">
						{{ rVisitorLogItem.DestinationFacilityLocation }}
					</div>
				</td>

				<td>
					<div class="table-data-log">
						{{ rVisitorLogItem.ScanStation }}
					</div>
				</td>

				<td>
					<div class="table-data-log">
						{{ rVisitorLogItem.Barcode }}
					</div>
				</td>

				<td>
					<div class="table-data-log">
						{{ rVisitorLogItem.FacilityName }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						  -->
<!-- Display When No Location -->
<!-- 					      -->
<div style="padding: 20px" [style.display]="lstVisitorLog.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No Visitor Logs Found...</label>
</div>

<!-- 				-->
<!-- Display Detail -->
<!-- 				-->
<div>
	<VPP-ViewVisitorDetail></VPP-ViewVisitorDetail>
</div>
